/**
 * UI-only helpers for Flight Status components.
 * API integration will use real data later.
 */

export function getBackgroundColor(colors) {
  if (!colors || !colors[0]) return {};
  return { backgroundColor: colors[0] };
}

export function getStrokeColor(bdrColor, isDefault = false) {
  let borderColor = {};
  if (Array.isArray(bdrColor) && bdrColor.length > 1) {
    borderColor = { borderColor: `${bdrColor[0]}` };
  } else if (bdrColor && bdrColor.length > 0) {
    borderColor = { borderColor: `${bdrColor}` };
  }
  if (isDefault) {
    return { border: `solid 1px ${borderColor.borderColor}` };
  }
  return borderColor;
}

/**
 * Replace density/type placeholders in icon URLs with actual density value.
 * Mirrors Flights-UI commonUtils replaceIcons.
 */
export function replaceIcons(url, density = "hdpi") {
  if (!url) return "";
  return url.replace("{type}", density).replace("%s", density).replace("{density}", density);
}

export function getBackgroundImage(image) {
  if (!image) return {};
  return { backgroundImage: `url(${image})` };
}

/** PWA only: detail route uses hyphenated path + `data` query (base64 JSON). */
const FLIGHT_STATUS_PWA_DETAIL_BASE = "https://www.makemytrip.com/flight/flight-status-detail";

/**
 * Payload for PWA flight-status-detail `data` param (base64 JSON).
 * Mirrors FIS status-stream bootstrap object.
 */
export function buildFlightStatusStreamPayload({
  flightCode,
  date,
  crId,
  currency = "INR",
  locale = "en",
}) {
  return {
    apiPath: "/api/v1/fis/status-stream",
    method: "Get",
    tabId: 0,
    closeIcon: "",
    cheaperCombos: null,
    addQueryParams: {
      crId: crId || "",
      currency,
      date,
      flightCode: flightCode || "",
      fsdk: "",
      locale,
      requestType: "byFlight",
    },
    giData: null,
  };
}

/**
 * JSON.stringify + base64 (btoa). Uses UTF-8 safe encoding for non-Latin1 characters.
 */
export function encodeFlightStatusStreamData(payload) {
  const json = JSON.stringify(payload);
  if (typeof btoa !== "undefined") {
    return btoa(unescape(encodeURIComponent(json)));
  }
  if (typeof Buffer !== "undefined") {
    return Buffer.from(json, "utf8").toString("base64");
  }
  return "";
}

export function getFlightStatusLocaleClient() {
  if (typeof window === "undefined") return "en";
  const ls = window.localeSettings || {};
  const raw = ls.language || window.lang || "en";
  const s = String(raw).toLowerCase();
  if (s === "eng" || s === "en" || s === "english") return "en";
  if (s.length >= 2) return s.slice(0, 2);
  return "en";
}

export function getFlightStatusCurrencyClient() {
  if (typeof window === "undefined") return "INR";
  const c = window.localeSettings?.currency;
  return c ? String(c).toUpperCase() : "INR";
}

export function buildFlightStatusPwaDetailUrlWithDataParam(payload) {
  const data = encodeFlightStatusStreamData(payload);
  const params = new URLSearchParams({ data });
  return `${FLIGHT_STATUS_PWA_DETAIL_BASE}?${params.toString()}`;
}
